export function roundupToTwoDecimalPlaces(price) {
  const twoDigits = parseFloat(price.toFixed(2))
  const fiveDigits = parseFloat(price.toFixed(5))
  if (twoDigits === fiveDigits) {
    return twoDigits
  }
  return Math.ceil(fiveDigits * 100) / 100
}

export function calculateTotalCost(passengerCount, unitPrice) {
  const totalCost = passengerCount * unitPrice
  return roundupToTwoDecimalPlaces(totalCost)
}

/**
 * Converts a dollar string to a cent string
 * @param {string} dollarString a dollar string at most 2 decimal places eg. '100.20'
 * @return {string} an integer string eg. '10020'
 */
function convertDollarStrToCentStr(dollarString) {
  if (!dollarString || !dollarString.split) {
    return ''
  }
  const [beforeDot, afterDot] = dollarString.split('.')
  return beforeDot + (afterDot || '').padEnd(2, '0').slice(0, 2)
}

/**
 * Converts a dollar string to a cent Integer
 * @param {string} amountInDollars a dollar string at most 2 decimal places eg. '100.20'
 * @return {Number} an integer eg. 10020
 */
export function dollarsStringToCentsInteger(amountInDollars) {
  const amountInCents = convertDollarStrToCentStr(amountInDollars)
  return Number(amountInCents)
}
